<template>
  <div>
    <footer>
      <div class="footer-width">
        <!-- 頁腳-文字連結 -->
        <div class="footer-top">
          <div v-if="themeConfig.showFooterText" class="footer-link-list">
            <h4>{{ $t('Bao.KatsuWIN') }}</h4>
            <a @click.prevent="$router.push('/page/agent')">
              {{ $t('Bao.affiliate') }}
            </a>
            <a @click.prevent="$router.push('/page/support')">
              {{ $t('Bao.support_center_footer') }}
            </a>
            <a href="https://www.katsuwin.ai/blog/" target="_blank">
              {{ $t('Bao.blog_text') }}
            </a>
            <a @click.prevent="$router.push('/page/sup-faq')">
              {{ $t('Bao.faq_footer') }}
            </a>
            <a href="https://katsuwinaffiliates.ai/" target="_blank">
              {{ $t('Bao.affiliates') }}
            </a>
          </div>

          <div class="footer-link-list">
            <template v-if="themeConfig.showFooterPageTerms">
              <h4>{{ $t('Bao.useful_link') }}</h4>
              <a @click.prevent="$router.push('/page/terms')">
                {{ $t('Bao.terms_conditions') }}
              </a>
            </template>
            <template v-if="themeConfig.showFooterText">
              <a @click.prevent="$router.push('/page/rule')">
                {{ $t('Bao.game_rule') }}
              </a>
              <a @click.prevent="$router.push('/page/sports-rule')">
                {{ $t('Bao.sports_rule') }}
              </a>
              <a @click.prevent="$router.push('/page/privacy')">
                {{ $t('Bao.agent_help_type_4') }}
              </a>
              <a @click.prevent="$router.push('/page/cookie-policy')">
                {{ $t('Bao.cookie_policy') }}
              </a>
              <a @click.prevent="$router.push('/page/sup-self-restraint')">
                {{ $t('Bao.res_gaming') }}
              </a>
            </template>
          </div>

          <div v-if="themeConfig.showFooterText && followMedia !== undefined" class="footer-link-list icon-link">
            <div class="footer-link-list icon-link">
              <h4>{{ $t('Bao.follow_us') }}</h4>
              <ul>
                <li
                  v-for="(item, key) in followMedia"
                  :key="key"
                >
                  <a :href="item.link" :target="newWindows(item)">
                    <img :src="item.image" alt="">
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- sns 手機版 -->
        <div v-if="themeConfig.showFollowUs" class="footer-link-list-mb icon-link">
          <span>{{ $t('Bao.follow_us') }}</span>
          <ul>
            <li
              v-for="(item, key) in followMedia"
              :key="key"
            >
              <a :href="item.link" :target="newWindows(item)">
                <img :src="item.image" alt="">
              </a>
            </li>
          </ul>
        </div>

        <!-- 客服資訊 -->
        <div class="footer-help">
          <h4 class="footer-title">
            {{ $t('Bao.footer_help') }}
          </h4>

          <div class="footer-help-list">
            <div v-if="themeConfig.showFooterHelpCenter" @click="goHelpCenter">
              <img
                :src="$getThemeImagePath('comments-question.svg')"
                alt="METHOD FOR USER TO CONTACT"
              >
              <p>{{ $t('Bao.chat_access') }}</p>
              <span><p>{{ $t('Bao.chat_start') }}</p></span>
              <p>{{ serviceHours }}</p>
            </div>
            <div>
              <img :src="$getThemeImagePath('email.svg')" alt="METHOD FOR USER TO CONTACT">
              <p>{{ $t('Bao.email_access') }}</p>
              <span><a :href="`mailto:${supportEMail}`"><p>{{ supportEMail }}</p></a></span>
              <p>{{ serviceHours }}</p>
            </div>
          </div>
        </div>

        <!-- 銀行 -->
        <div v-if="themeConfig.showFooterBank" class="footer-bank">
          <h4 class="footer-title">
            {{ $t('Bao.safe_payment') }}
          </h4>

          <ul>
            <li v-for="(safePayment, key) in sortedImages" :key="key">
              <img :src="safePayment.image" :alt="safePayment.name">
            </li>
          </ul>
        </div>

        <!-- 遊戲供應商 -->
        <div v-if="themeConfig.showFooterProviders" class="footer-providers">
          <h4 class="footer-title">
            {{ $t('Bao.event_daily_attend_game_provider_setting') }}
          </h4>

          <template v-if="main_image.sponsor_footer !== undefined">
            <ul class="footer_sponsor">
              <li v-for="(item, key) in main_image.sponsor_footer" :key="key">
                <img class="mw-100" :src="item.image" height="40" :alt="item.name">
              </li>
            </ul>
          </template>
        </div>

        <!-- 牌照 -->
        <div v-if="themeConfig.showFooterLicense" class="footer-licensed">
          <h4 class="footer-title">
            {{ $t('Bao.license') }}
          </h4>
          <div
            id="anj-5c72c516-517d-4335-bac9-33b0f916b5c3"
            data-anj-seal-id="5c72c516-517d-4335-bac9-33b0f916b5c3"
            data-anj-image-size="48"
            data-anj-image-type="basic-small"
          />
          <p>
            {{ $t('Bao.license_footer',{supportMail:supportEMail}) }}
          </p>
        </div>

        <!-- k站簡介 -->
        <div v-if="themeConfig.showFooterIntro" class="footer-intro">
          <h4 class="footer-title">
            {{ $t('Bao.platform_intro', {theme: theme}) }}
          </h4>
          <p>
            {{ $t('Bao.platform_intro_desc1') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc2')">
            {{ $t('Bao.platform_intro_desc2') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc3')">
            {{ $t('Bao.platform_intro_desc3') }}
          </p>
          <p v-if="showText('Bao.platform_intro_desc4')">
            {{ $t('Bao.platform_intro_desc4') }}
          </p>
        </div>

        <!-- 證照 -->
        <div v-if="themeConfig.showFooterResponsible" class="footer-responsible">
          <h4 class="footer-title">
            {{ $t('Bao.footer_responsible') }}
          </h4>

          <ul>
            <li>
              <img :src="$getThemeImagePath('footer_gaming1.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="$getThemeImagePath('footer_gaming2.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="$getThemeImagePath('footer_gaming3.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
            <li>
              <img :src="$getThemeImagePath('footer_gaming4.png')" alt="IMAGE OF RESPONSIE GAMING">
            </li>
          </ul>
        </div>

        <!-- 頁腳-版權 -->
        <div class="footer-Kcopyright">
          <p>Copyright © {{ createYear }} {{ brandName }}. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getCategory } from '@/api/game'
import { handleHelpCenterLink, newWindows, handleTokenUrl } from '@/utils/tool'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  mixins: [themeMixin],
  data() {
    return {
      main_image: null
    }
  },
  quickBars() {
    if (this.quickBars.length) {
      this.checkTokenUrl(this.licenseId)
    }
  },
  computed: {
    ...mapGetters(['token', 'user', 'brand', 'brandImage']),
    path() {
      return this.$route.path
    },
    banner() {
      return this.brand.banners[0]
    },
    sortedImages() {
      const images = this.brandImage?.safe_payment ?? []
      return [...images].sort((a, b) => (a?.sort ?? 0) - (b?.sort ?? 0))
    },
    quickBars() {
      return this.brand.quickBars
    },
    followMedia() {
      return this.brandImage.follow_media
    },
    supportEMail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    },
    brandName() {
      return process.env.VUE_APP_BRAND_NAME
    },
    theme() {
      if (this.isTheme('theme_gold')) {
        return '勝WIN'
      } else if (this.isTheme('theme_blue')) {
        return 'Ubt88'
      } else {
        return 'Jack Rabbit Apex'
      }
    },
    createYear() {
      return this.isTheme('theme_purple') ? 2026 : 2022
    },
    serviceHours() {
      return this.isTheme('theme_blue') ? this.$t('Bao.service_hours') : this.$t('Bao.chat_time')
    }
  },
  watch: {

  },
  mounted() {
    if (this.isTheme('theme_gold')) {
      this.showSealBasedOnDomain()

      // DO NOT REMOVE BELOW CODE, IT'S FOR LICENSE USED
      // eslint-disable-next-line
      anj_5c72c516_517d_4335_bac9_33b0f916b5c3.init() 
    }
  },
  created() {
    getCategory().then((response) => {
      this.$store.commit('SET_GAME_CATEGORY', response.data.data)
    })

    // main image
    if (this.brandImage !== null) {
      this.main_image = this.brandImage
    }
  },
  methods: {
    goHelpCenter() {
      const isGuest = !this.token
      const user = this.user
      const userInfo = this.user.memberInfo
      const vipInfo = this.user.vipInfo
      const dateFormatter = this.$options.filters.dateFormat

      handleHelpCenterLink(isGuest, this.banner, user, userInfo, vipInfo, dateFormatter)
    },
    showText(key) {
      return this.$t(key) && this.$t(key).trim().length > 0
    },
    newWindows(obj) {
      return newWindows(obj)
    },
    showSealBasedOnDomain() {
      const seal = document.getElementById('anj-5c72c516-517d-4335-bac9-33b0f916b5c3')
      seal.style.display = 'inline-block'
    },
    checkTokenUrl(licenseId) {
      let url = new URL(this.quickBars[0].url)
      // Update the pathname with the dynamic licenseId
      url.pathname = `/licence/${licenseId}/v2/open_chat.cgi`
      // If there's a token, handle it
      if (this.token) {
        // Assuming handleTokenUrl is a function that adds the token to the URL
        url = new URL(handleTokenUrl(url.toString(), this.token))
      }
      // Update the quickBars array with the new URL
      this.quickBars[0].url = url.toString()
      this.$store.commit('SET_URLINFO_CSURL', this.quickBars[0].url)
    }
  }
}
</script>
